import * as React from "react";
import { PdfPreviewRenderer, PreviewRendererProps } from "./PdfPreviewRenderer";
import { DocxPreviewRenderer } from "./DocxPreviewRenderer";

export type { PreviewRendererProps };

/**
 * Registry mapping file extensions to their preview renderer component.
 * To add a new format: create a renderer in this directory and add an entry here.
 */
export const PREVIEW_RENDERERS: Record<string, React.FC<PreviewRendererProps>> = {
    pdf: PdfPreviewRenderer,
    docx: DocxPreviewRenderer,
};
